import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
  renderField,
  required,
  renderTextArea,
  number,
  renderPass,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";

class DigitalOceanProviderFormTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentProvider: {},
    };
    this.submitApi = this.submitApi.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
  }

  componentDidMount() {
    if (this.props.current_provider) {
      this.props.initialize({
        vm_provider_config_name: this.props.current_provider.vm_provider_config_name,
        vm_provider_name: this.props.current_provider.vm_provider_name,
        digital_ocean_token: this.props.current_provider.digital_ocean_token,
        max_instances: this.props.current_provider.max_instances,
        region: this.props.current_provider.region,
        digital_ocean_droplet_image: this.props.current_provider.digital_ocean_droplet_image,
        digital_ocean_droplet_size: this.props.current_provider.digital_ocean_droplet_size,
        digital_ocean_tags: JSON.stringify(this.props.current_provider.digital_ocean_tags, null, 2),
        digital_ocean_sshkey_name: this.props.current_provider.digital_ocean_sshkey_name,
        digital_ocean_firewall_name: this.props.current_provider.digital_ocean_firewall_name,
        startup_script: this.props.current_provider.startup_script,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
      this.props.initialize({
        vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
        vm_provider_name: nextProps.current_provider.vm_provider_name,
        digital_ocean_token: nextProps.current_provider.digital_ocean_token,
        max_instances: nextProps.current_provider.max_instances,
        region: nextProps.current_provider.region,
        digital_ocean_droplet_image: nextProps.current_provider.digital_ocean_droplet_image,
        digital_ocean_droplet_size: nextProps.current_provider.digital_ocean_droplet_size,
        digital_ocean_tags: JSON.stringify(nextProps.current_provider.digital_ocean_tags, null, 2),
        digital_ocean_sshkey_name: nextProps.current_provider.digital_ocean_sshkey_name,
        digital_ocean_firewall_name: nextProps.current_provider.digital_ocean_firewall_name,
        startup_script: nextProps.current_provider.startup_script,
      });
    }
  }

  cancelButton() {
    this.props.cancel_button(userData)
  }

  submitApi(userData) {
    userData.vm_provider_name = "digital_ocean"
    this.props.submit_api(userData)
  }

  render() {
    const { handleSubmit } = this.props;
    const { currentProvider } = this.state;
    return (
      <Form onSubmit={handleSubmit(this.submitApi)}>
        <CardBody>
          <FormGroup>
            <Row>
              <Col>
                <Label htmlFor="vm_provider_config_name" className="requiredasterisk">Name </Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <Field type="text"
                  name="vm_provider_config_name"
                  id="vm_provider_config_name"
                  component={renderField}
                  validate={required}
                  placeholder="Example Digital Ocean Config"
                />
              </Col>
            </Row>
          </FormGroup>

          <FormGroup>
            <Row>
              <Col>
                <Label htmlFor="digital_ocean_token" className="requiredasterisk">Token</Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <Field type="password"
                  name="digital_ocean_token"
                  id="digital_ocean_token"
                  component={renderPass}
                  validate={required}
                />
              </Col>
            </Row>
          </FormGroup>
          <React.Fragment>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="max_instances" className="requiredasterisk">Max Droplets</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="number"
                    name="max_instances"
                    id="max_instances"
                    component={renderField}
                    validate={number}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="region" className="requiredasterisk">Region</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="region"
                    id="region"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="digital_ocean_droplet_image" className="requiredasterisk">Image</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="digital_ocean_droplet_image"
                    id="digital_ocean_droplet_image"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="digital_ocean_droplet_size" className="requiredasterisk">Droplet Size</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="digital_ocean_droplet_size"
                    id="digital_ocean_droplet_size"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="digital_ocean_tags" className="requiredasterisk">Tags</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="textarea"
                    name="digital_ocean_tags"
                    id="digital_ocean_tags"
                    component={renderTextArea}
                    placeholder='{"name":"value"}'
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="digital_ocean_sshkey_name" className="requiredasterisk">SSH Key Name</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="digital_ocean_sshkey_name"
                    id="digital_ocean_sshkey_name"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="digital_ocean_firewall_name" className="requiredasterisk">Firewall Name</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="digital_ocean_firewall_name"
                    id="digital_ocean_firewall_name"
                    component={renderField}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col>
                  <Label htmlFor="startup_script" className="requiredasterisk">Startup Script</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field type="text"
                    name="startup_script"
                    id="startup_script"
                    component={renderTextArea}
                    validate={required}
                  />
                </Col>
              </Row>
            </FormGroup>
          </React.Fragment>
        </CardBody>
        <CardFooter>
          <FormGroup className="form-actions">
            <Button type="button" size="sm"
              className="cancel-button"
              color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
            <Button type="submit"
              className="submit-button"
              size="sm" color="primary">{!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? 'Next' : 'Finish'}</Button>
          </FormGroup>
        </CardFooter>
      </Form>
    );
  }
}


DigitalOceanProviderFormTemplate.propTypes = {
  current_provider: Proptypes.object,
  submit_api: Proptypes.func.isRequired,
  handleSubmit: Proptypes.func,
  cancel_button: Proptypes.func,
};


let DigitalOceanProviderFormWithRouter = withRouter(DigitalOceanProviderFormTemplate);

let DigitalOceanProviderForm = connect(state => {

  return {
    vm_provider_configs: state.vm_provider.vm_provider_configs,
  }
},

  dispatch =>
  ({

  }))(DigitalOceanProviderFormWithRouter);

export default reduxForm({
  form: "VmProviderForm",
})(DigitalOceanProviderForm);
